// Permission catalogue shared by Provider → Settings → Roles & Permissions and
// by the Staff portal. The values mirror the backend enum exactly — the role
// editor renders whatever `/settings/permissions` returns, while the Staff
// portal gates routes and menu items against the list on `/staff/me`.

export const PERMISSION = {
	DASHBOARD_VIEW: 'DASHBOARD_VIEW',
	DASHBOARD_ANALYTICS: 'DASHBOARD_ANALYTICS',
	APPOINTMENT_VIEW: 'APPOINTMENT_VIEW',
	APPOINTMENT_CREATE: 'APPOINTMENT_CREATE',
	APPOINTMENT_EDIT: 'APPOINTMENT_EDIT',
	APPOINTMENT_DELETE: 'APPOINTMENT_DELETE',
	APPOINTMENT_SCHEDULE: 'APPOINTMENT_SCHEDULE',
	APPOINTMENT_HAIRCHART: 'APPOINTMENT_HAIRCHART',
	APPOINTMENT_COMPLETE: 'APPOINTMENT_COMPLETE',
	APPOINTMENT_REBOOK: 'APPOINTMENT_REBOOK',
	CUSTOMER_VIEW: 'CUSTOMER_VIEW',
	CUSTOMER_CREATE: 'CUSTOMER_CREATE',
	CUSTOMER_EDIT: 'CUSTOMER_EDIT',
	CUSTOMER_DELETE: 'CUSTOMER_DELETE',
	STAFF_VIEW: 'STAFF_VIEW',
	STAFF_MANAGE: 'STAFF_MANAGE',
	SCHEDULE_MANAGE: 'SCHEDULE_MANAGE',
	SERVICE_VIEW: 'SERVICE_VIEW',
	SERVICE_MANAGE: 'SERVICE_MANAGE',
	SETTINGS_ACCESS: 'SETTINGS_ACCESS',
	LOCATION_MANAGE: 'LOCATION_MANAGE',
	REPORTS_VIEW: 'REPORTS_VIEW',
	REPORTS_EXPORT: 'REPORTS_EXPORT',
	PAYMENT_VIEW: 'PAYMENT_VIEW',
	PAYMENT_MANAGE: 'PAYMENT_MANAGE',
	INVOICE_SEND_VIEW: 'INVOICE_SEND_VIEW',
	ADMIN_ROLE_MANAGEMENT: 'ADMIN_ROLE_MANAGEMENT',
	ADMIN_USER_MANAGEMENT: 'ADMIN_USER_MANAGEMENT',
} as const;

export type Permission = (typeof PERMISSION)[keyof typeof PERMISSION];

export const ALL_PERMISSIONS: Permission[] = Object.values(PERMISSION);

/**
 * The `auth` block on `GET /staff/me`. Absent for staff whose account predates
 * role assignment — treated as "no permissions", so anything gated stays shut
 * until a role is assigned. `permissions` is typed loosely because the backend
 * may add entries before the frontend enum catches up.
 */
export interface StaffAuth {
	roleId: number | null;
	roleName: string | null;
	roleType: string | null;
	permissions: string[];
}
